import { Theme } from "@mui/material";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme: Theme) => ({
  block: {
    color: theme.vars.palette.filter.text,
    width: "200px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "initial",
  },
}));
export const FilterGroupName = ({ name }: { name: string }) => {
  const { classes } = useStyles();

  return <div className={classes.block}>{name}</div>;
};
